import {
  DemocracyEngineAccount,
  DemocracyEngineAuthenticationToken,
  DemocracyEngineDonationRequest,
  DemocracyEngineRecipient
} from '../../types/democracy-engine'

const netlifyFetch = async <T>(endpoint: string, init?: RequestInit): Promise<T> => {
  const response = await fetch(`/.netlify/functions/${endpoint}`, {
    headers: {
      'Content-Type': 'application/json',
      ...init?.headers
    },
    ...init
  })

  if (!response.ok) {
    const message = await response.text()
    throw new Error(message || `Failed to call ${endpoint}`)
  }

  return (await response.json()) as T
}

export const fetchDemocracyEngineAccount = () =>
  netlifyFetch<DemocracyEngineAccount>('democracy-engine-account')

export const fetchDemocracyEngineRecipients = () =>
  netlifyFetch<DemocracyEngineRecipient[]>('democracy-engine-recipients')

export const requestDemocracyEngineAuthToken = (batchSize?: number) =>
  netlifyFetch<DemocracyEngineAuthenticationToken | DemocracyEngineAuthenticationToken[]>(
    `democracy-engine-auth-token${batchSize ? `?batchSize=${batchSize}` : ''}`,
    { method: 'POST' }
  )

export const submitDemocracyEngineDonation = (payload: DemocracyEngineDonationRequest) =>
  netlifyFetch('democracy-engine-donation', {
    method: 'POST',
    body: JSON.stringify(payload)
  })

export const proxyBrowserDemocracyEngineDonation = (payload: DemocracyEngineDonationRequest) =>
  netlifyFetch('democracy-engine-browser-donation', {
    method: 'POST',
    body: JSON.stringify(payload)
  })
